export const CONSENT_STORAGE_KEY = 'leadsme:cookie_consent';

/** Bump when cookie categories or legal basis change to re-prompt users. */
export const CONSENT_VERSION = 1;

export type ConsentPreferences = {
  marketing: boolean;
};

export type StoredConsent = ConsentPreferences & {
  version: number;
  decidedAt: string;
};

export const readStoredConsent = (): StoredConsent | null => {
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as StoredConsent;
    if (
      typeof parsed.version !== 'number' ||
      typeof parsed.marketing !== 'boolean' ||
      typeof parsed.decidedAt !== 'string'
    ) {
      return null;
    }

    if (parsed.version < CONSENT_VERSION) return null;

    return parsed;
  } catch {
    return null;
  }
};

export const writeStoredConsent = (prefs: ConsentPreferences): StoredConsent => {
  const stored: StoredConsent = {
    ...prefs,
    version: CONSENT_VERSION,
    decidedAt: new Date().toISOString(),
  };

  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(stored));
  } catch {
    // Storage may be blocked (private mode, browser settings).
  }

  return stored;
};
